(function () {
    'use strict';

    angular.module("imApp").factory("travExpTypeMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getTravelExpenceType: function (parms) {
                return $ihttp.post({
                    method: 1269,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1273,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
